var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"introduction"}},[_c('h2',{staticClass:"title"},[_c('a',{staticClass:"prev",on:{"click":_vm.back}}),_vm._v("\n      关于我们\n    ")]),_vm._v(" "),_c('h1',[_vm._v("简介")]),_vm._v(" "),_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(_vm.textData)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2444afe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/Introduction.vue
// module id = null
// module chunks = 